// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"btn-group_wrapper__DgWBk"};